module.exports = __webpack_public_path__ + "media/assets/icons/playbook-diagram-icon-purple-fa386a3fb52b61063fb8e2098dbfcfea.png";